import {Tilemaps} from "phaser";
import {MainScene} from "../scenes/MainScene";

export class GameMap {

    private scene: MainScene;
    public layerBuildings : Phaser.Tilemaps.DynamicTilemapLayer;
    public layerLadder : Phaser.Tilemaps.DynamicTilemapLayer;
    public layerTopLadder : Phaser.Tilemaps.DynamicTilemapLayer;
    public layerDoorEnd : Phaser.Tilemaps.DynamicTilemapLayer;
    private layerLastBuilding: Tilemaps.DynamicTilemapLayer;


    constructor (scene: MainScene) {
        this.scene = scene;
    }

    private static isIe(): boolean {
        let ua: string = window.navigator.userAgent;
        return /MSIE|Trident/.test(ua);
    }

    public loadImages(): void {
        /**
         * caricamento delle immagini dei tilesets usati per creare la mappa su Tiled
         */

        this.scene.load.image('tilesBackground', 'assets/tilesets/map/background-extruded.png');
        this.scene.load.image('tilesSections', 'assets/tilesets/map/sections-extruded.png');
        this.scene.load.image('tilesBuildings', 'assets/tilesets/map/buildings-extruded.png');

        this.scene.load.image('flag', 'assets/elements/flag.png');
        this.scene.load.image('lines', 'assets/elements/redLine.png');

        if (!this.scene.isMobile()) {
            this.scene.load.image("cursorInstructions", "assets/instructions/CursorsKeysInstructions.png");
            this.scene.load.image("jumpInstructions", "assets/instructions/JumpKeyInstructions.png");
        }

        else {
            this.scene.load.image("cursorInstructions", "assets/instructions/JoystickInstructions.png");
            this.scene.load.image("jumpInstructions", "assets/instructions/JumpButtonInstructions.png");
        }
    }

    public createMap(map: Tilemaps.Tilemap): void {
        /**
         * aggiunta delle immagini sulla mappa 
         */
        let tilesetBackground = map.addTilesetImage("background", "tilesBackground", 13, 13, 1, 2);
        let tilesetSections = map.addTilesetImage("sections", "tilesSections", 13, 13, 1, 2);
        let tilesetBuildings = map.addTilesetImage("buildings", "tilesBuildings", 13, 13, 1, 2);

        /**
         * questo ordine determina la visualizzazione sulla mappa della profondità tra i layer (come su Tiled)
         */
        map.createDynamicLayer('sky', tilesetBackground);
        map.createDynamicLayer('mountain', tilesetBackground);
        map.createDynamicLayer('sectionsLayer', tilesetSections);
        this.layerBuildings = map.createDynamicLayer('buildingsLayer', tilesetBuildings);
        map.createDynamicLayer('floorCity', tilesetBackground);  
        
        this.layerLadder = map.createDynamicLayer('ladderLayer', tilesetBuildings);
        this.layerTopLadder = map.createDynamicLayer('topLadder', tilesetBuildings);
        this.layerDoorEnd = map.createDynamicLayer('doorEnd', tilesetSections);
        this.layerLastBuilding = map.createDynamicLayer('lastBuilding', tilesetSections);

        /**
         * setto la visibilità di alcuni layer { (0) = invisibile, (1) = visibile }
         */
        this.layerDoorEnd.setAlpha(0);      
        this.layerTopLadder.setAlpha(0);  
        this.layerLastBuilding.setDepth(1);
    }

    public setCollision(): void {
        /**
         * collisione con gli edifici data dalla proprietà 'collides' aggiunta al tileset buildings su Tiled
         */
        this.layerBuildings.setCollisionByProperty({collides: true});
    }

}
